import styled from '@emotion/styled';
import { Alert as RawAlert, tokens } from '@hotjar/hotsauce';

export const Alert = styled(RawAlert)`
  padding: ${tokens.spacer.x1pt5};
  gap: ${tokens.spacer.x1pt5};
`;
